import React, { useEffect, useState } from 'react';
import { loadTranslate, saveTranslate } from '../utils/Network';

export default function TranslateFormContent({
    id,
    languages,
    variant = 'page',
    onSaved,
    onCancel,
}) {
    const [key, setKey] = useState('');
    const [values, setValues] = useState(null);

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const isModal = variant === 'modal';

    useEffect(() => {
        setError(null);
        if (id) {
            loadTranslate(id).then((translate) => {
                setKey(translate.key);
                setValues(translate.values);
            });
        } else {
            setKey('');
            setValues(null);
        }
    }, [id]);

    const onChange = (e) => {
        switch (e.target.name) {
            case 'key':
                setKey(e.target.value);
                break;
            default:
                break;
        }
    };

    const handleValueChange = (e, language_id) => {
        let value = null;
        if (values) {
            value = values.find((x) => x.language === parseInt(language_id, 10));
        }
        if (value) {
            const temp_values = [...values];
            temp_values.find((x) => x.language === parseInt(language_id, 10)).value = e.target.value;
            setValues(temp_values);
        } else {
            const new_value = { value: e.target.value, language: parseInt(language_id, 10) };
            let temp = [];
            if (values) temp = [...values, new_value];
            else temp = [new_value];

            setValues(temp);
        }
    };

    const saveChanges = () => {
        setError(null);
        setLoading(true);

        if (key.length < 1) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }

        const hasAnyTranslation =
            values &&
            values.some((v) => v && v.value != null && String(v.value).trim().length > 0);
        if (!hasAnyTranslation) {
            setError('Please Enter translation');
            setLoading(false);
            return;
        }

        saveTranslate({ id, key, values })
            .then((data) => {
                setLoading(false);
                if (onSaved) {
                    onSaved(data);
                } else {
                    setKey('');
                    setValues(null);
                }
            })
            .catch(() => {
                setLoading(false);
                setError('Save failed');
            });
    };

    const inner = (
        <>
            <div className={isModal ? ' mb-0' : ''}>
                
                <div className="box-body no-border padding-10 overflow-hidden">
                    <form className="form-horizontal" onSubmit={(e) => e.preventDefault()}>
                        <div className="form-group row">
                            <div className="col-sm-12 mb-5">
                                <input
                                    type="text"
                                    value={key}
                                    name="key"
                                    onChange={onChange}
                                    className="form-control"
                                    placeholder="Key"
                                />
                            </div>
                            {languages &&
                                languages.map((lan) => (
                                    <div key={lan.id} className="col-sm-12 mb-5">
                                        <textarea
                                            value={values?.find((x) => x.language === parseInt(lan.id, 10))?.value || ''}
                                            onChange={(e) => {
                                                handleValueChange(e, lan.id);
                                            }}
                                            className="form-control kfont"
                                            placeholder={lan.name}
                                            rows={3}
                                        />
                                    </div>
                                ))}
                        </div>
                    </form>
                </div>
                <div className="box-footer clearfix">
                    {(id || isModal) && (
                        <button
                            type="button"
                            className="btn btn-cm pull-left"
                            onClick={() => {
                                if (onCancel) onCancel();
                            }}
                        >
                            Cancel
                        </button>
                    )}

                    <button
                        type="button"
                        onClick={saveChanges}
                        disabled={loading}
                        className="btn btn-cm pull-right"
                    >
                        Save changes
                    </button>
                </div>
            </div>
            {error && <div className="alert alert-danger mt-10 mb-0">{error}</div>}

            {loading && (
                <div className="alert alert-info mt-10 mb-0">Please wait…</div>
            )}
        </>
    );

    if (isModal) {
        return <div className="translate-form-modal-inner text-left">{inner}</div>;
    }

    return <div className="col-md-6">{inner}</div>;
}
